// Country to Continent Mapping
// Maps country positions/regions in the SVG to their respective continents

export const countryToContinentMap = {
  // This will be populated based on geographic coordinates from the SVG
  // For now, we'll detect continent based on path position (x, y coordinates)
};

// Function to detect continent based on SVG path bounding box
export const detectContinentFromBounds = (bbox) => {
  const centerX = bbox.x + bbox.width / 2;
  const centerY = bbox.y + bbox.height / 2;
  
  // Calculate area to filter out very small paths
  const area = bbox.width * bbox.height;
  const MIN_AREA = 50; // Minimum area threshold
  
  // Debug logging - will help calibrate ranges for new SVG
  if (area >= MIN_AREA) {
    console.log(`Path detected - centerX: ${centerX.toFixed(1)}, centerY: ${centerY.toFixed(1)}, area: ${area.toFixed(1)}`);
  }
  
  // If path is too small, ignore it
  if (area < MIN_AREA) {
    return { id: 'unknown', name: 'Unknown' };
  }
  
  // Based on NEW viewBox 0 0 350 250 (clean map)
  // Calibrated ranges based on user testing - expanded to close gaps
  
  // South America: Bottom left (extended north to include Venezuela, Colombia)
  if (centerX >= 70 && centerX <= 135 && centerY >= 140 && centerY <= 210) {
    return { id: 'south_america', name: 'South America' };
  }
  
  // North America: Top left (includes Greenland, USA, Canada, Central America, Caribbean)
  if (centerX >= 30 && centerX <= 135 && centerY >= 50 && centerY <= 139) {
    return { id: 'north_america', name: 'North America' };
  }
  
  // Africa: Bottom middle (extended north to include Morocco, Algeria, Libya, Egypt)
  if (centerX >= 145 && centerX <= 215 && centerY >= 120 && centerY <= 205) {
    return { id: 'africa', name: 'Africa' };
  }
  
  // Europe: Top middle (includes Iceland, extended slightly)
  if (centerX >= 140 && centerX <= 215 && centerY >= 85 && centerY <= 119) {
    return { id: 'europe', name: 'Europe' };
  }
  
  // Oceania: Bottom right (includes all Pacific islands)
  if (centerX >= 255 && centerX <= 335 && centerY >= 165 && centerY <= 225) {
    return { id: 'oceania', name: 'Oceania' };
  }
  
  // Asia: Top right (large region, includes Middle East, Russia, Southeast Asia)
  if (centerX >= 215 && centerX <= 335 && centerY >= 80 && centerY <= 170) {
    return { id: 'asia', name: 'Asia' };
  }
  
  // Default fallback for ocean/unlabeled areas
  return { id: 'unknown', name: 'Unknown' };
};
